import { FhirComponentRegistry } from '../core/registry';

import { AllergyIntoleranceView } from './allergy-intolerance';
import { AppointmentView } from './appointment';
import { ConditionView } from './condition';
import { DiagnosticReportView } from './diagnostic-report';
import { EncounterView } from './encounter';
import { GenericView } from './generic/GenericView';
import { GoalView } from './goal';
import { HealthcareServiceView } from './healthcare-service';
import { ImmunizationView } from './immunization';
import { LocationView } from './location';
import { MedicationView } from './medication';
import { MedicationRequestView } from './medication-request';
import { ObservationView } from './observation';
import { PatientView } from './patient';
import { PractitionerView } from './practitioner';
import { ProcedureView } from './procedure';

export function buildDefaultRegistry(): FhirComponentRegistry {
  return new FhirComponentRegistry()
    .register({
      id: 'allergy-intolerance',
      resourceType: 'AllergyIntolerance',
      component: AllergyIntoleranceView,
    })
    .register({
      id: 'appointment',
      resourceType: 'Appointment',
      component: AppointmentView,
    })
    .register({
      id: 'condition',
      resourceType: 'Condition',
      component: ConditionView,
    })
    .register({
      id: 'diagnostic-report',
      resourceType: 'DiagnosticReport',
      component: DiagnosticReportView,
    })
    .register({
      id: 'encounter',
      resourceType: 'Encounter',
      component: EncounterView,
    })
    .register({
      id: 'goal',
      resourceType: 'Goal',
      component: GoalView,
    })
    .register({
      id: 'healthcare-service',
      resourceType: 'HealthcareService',
      component: HealthcareServiceView,
    })
    .register({
      id: 'immunization',
      resourceType: 'Immunization',
      component: ImmunizationView,
    })
    .register({
      id: 'location',
      resourceType: 'Location',
      component: LocationView,
    })
    .register({
      id: 'medication',
      resourceType: 'Medication',
      component: MedicationView,
    })
    .register({
      id: 'medication-request',
      resourceType: 'MedicationRequest',
      component: MedicationRequestView,
    })
    .register({
      id: 'observation',
      resourceType: 'Observation',
      component: ObservationView,
    })
    .register({
      id: 'patient',
      resourceType: 'Patient',
      component: PatientView,
    })
    .register({
      id: 'practitioner',
      resourceType: 'Practitioner',
      component: PractitionerView,
    })
    .register({
      id: 'procedure',
      resourceType: 'Procedure',
      component: ProcedureView,
    })
    .registerFallback(GenericView);
}
